import { ESIInclude } from "@packages/esi-include/ESIInclude";

export function WishList() {
  const srcUrl = "/add-to-wishlist/exclude-cpa.html";

  return (
    <div
      id="add-to-wish-list-esi"
      data-testid="wishlist"
      data-component="WishList"
      data-mode="icon-placeholder"
    >
      <ESIInclude src={srcUrl} id="wishlist" />
    </div>
  );
}
